import { initPopover } from './init_popover';
import { Modal } from 'bootstrap';
export function initMultistepForm() {
  // Function to initialize form functionality
  function initFormFunctionality() {
    const nextButtons = document.querySelectorAll('.next-step');
    const prevButtons = document.querySelectorAll('.prev-step');
    let currentStep = 0;

    const steps = document.querySelectorAll('.form-step');
    const stepIndicators = document.querySelectorAll('.kn_step-indicator__item');

    function updateStepIndicator(stepIndex) {
      stepIndicators.forEach((indicator, index) => {
        if (index < stepIndex) {
          indicator.classList.add('completed');
          indicator.classList.remove('active');
        } else if (index === stepIndex) {
          indicator.classList.add('active');
          indicator.classList.remove('completed');
        } else {
          indicator.classList.remove('active', 'completed');
        }
      });
    }

    function collectAnswers() {
      let answersText = '';
      const inputs = document.querySelectorAll('input[data-question]');
      let currentName = '';
      let currentQuestion = '';
      
      inputs.forEach((input, index) => {
        const question = input.dataset.question;
        const name = input.getAttribute('name');
        
        if(input.type === 'checkbox') {
          // Start new question group if needed
          if(question !== currentQuestion) {
            if(currentQuestion) {
              answersText = answersText.replace(/,\s*$/, '\n'); // Remove trailing comma and add newline for previous group
            }
            answersText += '\nFrage: ' + question + '\nAntwort: ';
            currentQuestion = question;
            currentName = name;
          }
          
          if(input.checked) {
            answersText += input.value + ', ';
          }
          
          // If next input has different name or is last input, end the group
          const nextInput = inputs[index + 1];
          if(!nextInput || nextInput.getAttribute('name') !== name) {
            answersText = answersText.replace(/,\s*$/, '\n');
          }
          
        } else if(input.type === 'radio') {
          // Nur wenn Radio Button ausgewählt ist und neue Frage beginnt
          if(input.checked && (!currentQuestion || question !== currentQuestion)) {
            if(currentQuestion) {
              answersText += '\n';
            }
            answersText += '\nFrage: ' + question + '\nAntwort: ' + input.value + '\n';
            currentQuestion = question;
          }
        } else if(input.type === 'text' || input.type === 'date') {
          if(input.value.trim()) {
            let value = input.value;
            if(input.type === 'date') {
              // Convert date from YYYY-MM-DD to DD.MM.YYYY
              const dateParts = input.value.split('-');
              value = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
            }
            answersText += '\nFrage: ' + question + '\nAntwort: ' + value + '\n';
          }
        }
      });
      
      return answersText;
    }

    function validateStep(step) {
      let valid = true;
      const inputs = steps[step].querySelectorAll('input[required]');
      const checkboxGroups = steps[step].querySelectorAll('.checkbox-group[data-required="true"]');
      const radioGroups = steps[step].querySelectorAll('.radio-group[data-required="true"]');

      inputs.forEach(input => {
        if (!input.value.trim()) {
          valid = false;
        }
        if (input.type === 'text' && input.value.trim().length > 100) {
          valid = false;
        }
      });

      checkboxGroups.forEach(group => {
        const checkboxes = group.querySelectorAll('input[type="checkbox"]');
        let checked = false;
        checkboxes.forEach(checkbox => {
          if (checkbox.checked) {
            checked = true;
          }
        });
        if (!checked) {
          valid = false;
        }
      });

      // Validierung für Radio-Gruppen
      radioGroups.forEach(group => {
        const radios = group.querySelectorAll('input[type="radio"]');
        let checked = false;
        radios.forEach(radio => {
          if (radio.checked) {
            checked = true;
          }
        });
        if (!checked) {
          valid = false;
        }
      });

      return valid;
    }

    nextButtons.forEach(button => {
      button.addEventListener('click', () => {
        if (validateStep(currentStep)) {
          steps[currentStep].style.display = 'none';
          currentStep++;
          steps[currentStep].style.display = 'flex';
          updateStepIndicator(currentStep);
          
          // Update form_steps textarea when reaching contact form
          if(currentStep === steps.length - 1) {
            const formAnswersTextarea = steps[currentStep].querySelector('textarea[name="form_steps"]');
            if(formAnswersTextarea) {
              formAnswersTextarea.value = collectAnswers();
            }
          }
        } else {
          steps[currentStep].querySelector('.error-message').style.display = 'flex';
        }
      });
    });

    prevButtons.forEach(button => {
      button.addEventListener('click', () => {
        steps[currentStep].style.display = 'none';
        currentStep--;
        steps[currentStep].style.display = 'flex';
        updateStepIndicator(currentStep);
        steps[currentStep].querySelector('.error-message').style.display = 'none';
      });
    });

    // Initialisiere den ersten Step-Indicator
    updateStepIndicator(0);

    // Listen for successful form submission
    document.addEventListener('wpcf7mailsent', function(event) {
        const successModal = new Modal(document.getElementById('successModal'));
        successModal.show();
        // Hide wpcf7-response-output after successful submission
        const responseOutput = document.querySelector('.wpcf7-response-output');
        if (responseOutput) {
            responseOutput.style.display = 'none';
        }
        const lastStep = steps[steps.length - 1];
        const prevButton = lastStep.querySelector('.prev-step');
        if(prevButton) {
            prevButton.style.display = 'none';
        }
    });

    const successModal = document.getElementById('successModal');
    if (successModal) {
      successModal.addEventListener('hidden.bs.modal', function () {
        window.location.reload();
      });
    }
  }

  // Form Loading via AJAX
  function loadFormViaAjax(formId, targetElement) {
    const data = new FormData();
    data.append('action', 'load_multistep_form');
    data.append('form_id', formId);
    data.append('nonce', knineAjax.nonce); // Sicherheits-Nonce

    fetch(knineAjax.ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      body: data
    })
    .then(response => response.text())
    .then(html => {
      targetElement.innerHTML = html;
      const wrapper = document.querySelector('#multistep-form-list-wrapper');
      wrapper.style.display = 'none'; 
      targetElement.style.display = 'block';       
      const form = document.querySelector('.wpcf7-form');
      // Initialisiere das Formular mit wpcf7
      if (form && typeof wpcf7 !== 'undefined') {
        wpcf7.init(form);
      }
      initFormFunctionality(); // Initialisiere Form-Funktionalität nach dem Laden
      initPopover(); // Initialize popovers after form is loaded
    })
    .catch(error => console.error('Error loading form:', error));
  }

  // Event Delegation für Form-Trigger
 
    const dataFormItem = document.querySelectorAll('[data-form-id]');
    dataFormItem.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const formId = item.dataset.formId;
        const targetWrapper = document.querySelector('#multistep-form-list-load-wrapper');
        if (targetWrapper) {
          loadFormViaAjax(formId, targetWrapper);         
        }
      });
    });
    
    document.addEventListener('click', function(e) {
      if (e.target.matches('.back-to-list')) {
        e.preventDefault();
        const wrapper = document.querySelector('#multistep-form-list-wrapper');
        wrapper.style.display = 'flex';
        const targetElement = document.querySelector('#multistep-form-list-load-wrapper');
        targetElement.style.display = 'none';
      }
    });

  // If form is already present on page load, initialize it
  if (document.querySelectorAll('.form-step').length > 0) {
    initFormFunctionality();
    initPopover(); // Initialize popovers for forms present on page load
  }
}